import {AxiosError, AxiosResponse} from "axios";
import {AppStore} from "../store/app.store";

export class ApiResponseHandler {
    public static handleSuccess (response: AxiosResponse<any, any>) {
        return response
    }

    public static handleError (error: AxiosError<any, any>) {

        if (error.response) {
            const { response : { status } } = error;

            if (status === 401) {
                document.location.reload();
            }
        }

        throw error;
    }

    public static handleResponseRedirects (error: AxiosError<any, any>) {
        if (error.response && error.response.status === 403) {
            window.location.href = "/";
        }
    }
}